import * as React from "react";
import { useState, useEffect, useRef } from "react";
import { Card, CardBody, CardHeader, Row } from "reactstrap";
import avatar2 from "../../assets/images/users/avatar-2.jpg";
import axios from "axios";
import moment from "moment";
import Breadcrumb from "../../components/Common/Breadcrumb";
import Pusher from "pusher-js";
import imageCompression from "browser-image-compression";

export default function ComunityChat(props) {
  const now = moment();
  const student_course = props.location.state
    ? props.location.state.student_course
    : props.history.push("comunity");
  const course_id = props.location.state
    ? props.location.state.course_id
    : props.history.push("comunity");
  const batch_id = props.location.state
    ? props.location.state.batch_id
    : props.history.push("comunity");
  const [messages, setMessages] = useState([]);
  const [message, setMessage] = useState("");
  const [username, setusername] = useState(
    JSON.parse(localStorage.getItem("authUser")).data.name
  );
  const [isCompressing, setIsCompressing] = useState(false); // State to track compression
  const [originalFileSize, setOriginalFileSize] = useState(0); // Track original file size
  const [compressedFileSize, setCompressedFileSize] = useState(0); // Track compressed file size
  const [isSafe, setIsSafe] = useState(null);
  const [filePreview, setFilePreview] = useState(null); // To store and display the image preview
  const [selectedFile, setSelectedFile] = useState(null);

  const [course, setCourse] = useState("");

  const messageContainerRef = useRef(null);
  const messagesEndRef = useRef(null);
  let event = course_id + "-" + batch_id;

  axios.defaults.headers.common[
    "Authorization"
  ] = `Bearer ${global.config.Token}`;

  const handleFileChange = async (e) => {
    const file = e.target.files[0]; // Get the selected file
  
    if (file) {
      const fileSizeInMB = (file.size / 1024 / 1024).toFixed(2); // Original file size in MB
      setOriginalFileSize(fileSizeInMB);
  
      // Convert the file to base64 format for moderation
      const reader = new FileReader();
  
      reader.onloadend = async () => {
        const base64Image = reader.result.split(',')[1]; // Extract base64 data
  
        // Call Google Cloud Vision API for content moderation
        const isSafe = await checkImageForInappropriateContent(base64Image);
  
        if (!isSafe) {
          alert('The uploaded image contains inappropriate content. Please upload a safe image.');
          return; // Stop the process if image is inappropriate
        }
  
        // If the image is safe, proceed with compression if needed
        if (file.size > 1 * 1024 * 1024) {
          try {
            setIsCompressing(true); // Show loader while compressing
  
            const options = {
              maxSizeMB: 1, // Maximum size of the compressed image
              maxWidthOrHeight: 1024, // Resize if needed
              useWebWorker: true, // Use multi-threading for faster compression
            };
  
            const compressedFile = await imageCompression(file, options);
            const compressedFileSizeInMB = (compressedFile.size / 1024 / 1024).toFixed(2);
            setCompressedFileSize(compressedFileSizeInMB);
  
            const compressedReader = new FileReader();
            compressedReader.onloadend = () => {
              setFilePreview(compressedReader.result); // Set preview
              setSelectedFile(compressedFile); // Store the compressed file
              setIsCompressing(false); // Hide loader after compression
            };
  
            compressedReader.readAsDataURL(compressedFile); // Read compressed file
          } catch (error) {
            console.error('Error during image compression', error);
            setIsCompressing(false); // Hide loader if error occurs
          }
        } else {
          setFilePreview(reader.result); // Set preview with original file data
          setSelectedFile(file); // Store the original file
        }
      };
  
      reader.readAsDataURL(file); // Read the original file as a data URL
    } else {
      setSelectedFile(null); // Reset if no file is selected
      setFilePreview(null); // Reset preview
    }
  };
  
  // Function to check image content using Google Cloud Vision API
  const checkImageForInappropriateContent = async (base64Image) => {
    const apiKey = '709060306'; // Replace with your actual API key
    const apiSecret = 'YvujCVzpjRH5BRehEyWT896wx8GY5K9w'; // Replace with your actual API secret

   

    try {
      const response = await axios.post(
        `https://api.sightengine.com/1.0/transform.json`,
        new URLSearchParams({
          media: base64Image,
          models: 'nudity,wad,offensive',
          api_user: apiKey,
          api_secret: apiSecret,
        })
      );

      const result = response.data;

      // Check if the image is safe based on nudity and offensive content
      const isSafeContent = result.nudity.safe > 0.75 && result.offensive.prob < 0.75;

      setIsSafe(isSafeContent);
    } catch (error) {
      console.error('Error checking image content:', error);
      setIsSafe(false); // Consider the image unsafe if an error occurs
    } finally {
      
    }
  };
  
  

  const removeFilePreview = () => {
    setFilePreview(null); // Remove the preview if user wants to cancel
    setSelectedFile(null);
    document.getElementById("file-input").value = ""; // Clear the file input
  };
  useEffect(() => {
    // Enable pusher logging - don't include this in production
    //     Pusher.logToConsole = true;

    const pusher = new Pusher("e4d6748d6ab573a39b5f", {
      cluster: "ap2",
    });
    console.log(event);
    const channel = pusher.subscribe("my-channel");

    const handlePusherEvent = (data) => {
      //  console.log()
      const messageData = data.message;
      let message;
      if (typeof messageData === "string") {
        try {
          message = JSON.parse(messageData);
        } catch (error) {
          console.error("Error parsing JSON:", error);
          message = null; // Handle error case
        }
      } else {
        message = messageData; // Use it directly if it's already an object
        console.log(message.sender, "message.sender");
      }
      if (message.sender !== student_course) {
        setMessages((prev) => [...prev, JSON.parse(data.message)]);
      }
    };

    // Bind the event to the callback function
    channel.bind(event, handlePusherEvent);

    // Cleanup function to unsubscribe from the channel when the component unmounts
    return () => {
      channel.unbind("my-channel", handlePusherEvent);
      pusher.unsubscribe(event);
    };
  }, []);
  useEffect(() => {
    axios.defaults.headers.common[
      "Authorization"
    ] = `Bearer ${global.config.Token}`;

    const getChat = async () => {
      const chat = await axios.post(
        global.config.URL.api.lms + "get-messages",
        { course: student_course }
      );
      //    console.log(chat.data)
      setMessages(chat.data.chat);
      setCourse(chat.data.course);
    };
    getChat();
  }, []);

  const postMessage = async (messageData, setSelectedFile, setFilePreview) => {
    try {
      const formData = new FormData();
      const { temp, ...dataWithoutTemp } = messageData;
      // Append message details to FormData
      formData.append("message", JSON.stringify(dataWithoutTemp)); // Convert message to JSON string
      formData.append("course", student_course); // Add the course
      if (selectedFile) {
        formData.append("file", selectedFile); // Append the file if it exists
      }

      // Send the request
      await axios
        .post(global.config.URL.api.lms + "post-message", formData, {
          headers: {
            "Content-Type": "multipart/form-data", // Set content type for file upload
          },
        })
        .then(() => {
          setSelectedFile(null);
        });
    } catch (error) {
      console.error("Error posting message:", error);
      // Handle the error appropriately
      throw error; // Rethrow or handle the error as needed
    }
  };

  const sendMessage = async (e) => {
    e.preventDefault();
    const messageData = {
      sender_name: username,
      sender: student_course,
      receiver: "PFTP",
      message,
      file: selectedFile ? true : null,
      temp: selectedFile ? filePreview : null,
    };

    setMessage("");
    setFilePreview(null);
    setMessages((prev) => [...prev, messageData]);
    await postMessage(messageData, setSelectedFile, setFilePreview);
  };

  useEffect(() => {
    // Scroll to the bottom when messages change
    if (messageContainerRef.current) {
      messageContainerRef.current.scrollTop =
        messageContainerRef.current.scrollHeight;
    }
  }, [messages]);
  return (
    <React.Fragment>
      <div className="page-content">
        <Breadcrumb
          title="Dashboard"
          breadcrumbItem={`PFTP | ${course}  Comunity`}
        />
        <div class="page">
          <div class="marvel-device nexus5">
            <div class="top-bar"></div>
            <div class="sleep"></div>
            <div class="volume"></div>
            <div class="camera"></div>
            <div class="screen">
              <div class="screen-container">
                <div class="chat">
                  <div class="chat-container">
                    <div class="user-bar">
                      <div class="back">
                        <i class="zmdi zmdi-arrow-left"></i>
                      </div>
                      <div class="avatar">
                        <img src={avatar2} alt="Avatar" />
                      </div>
                      <div class="name">
                        <span>
                          PFTP | {course} Comunity <small>(BETA)</small>
                        </span>
                        <span class="status">online</span>
                      </div>
                    </div>
                    <div class="conversation">
                      <div
                        class="conversation-container"
                        ref={messageContainerRef}
                      >
                        {messages.map((message, index) => (
                          <div
                            class={
                              message.sender === student_course
                                ? "message sent"
                                : "message received"
                            }
                          >
                            <span className="sender">
                              {message.sender !== student_course
                                ? message.sender_name
                                : ""}
                            </span>
                            {message.file ? (
                              <img
                                src={
                                  message.temp
                                    ? message.temp
                                    : global.config.URL.img.public +
                                      message.file_path
                                }
                                alt=""
                              />
                            ) : (
                              ""
                            )}
                            {message.message}
                            <span class="metadata">
                              <span class="time">
                                {now.diff(message.timestamp, "hours") <= 2
                                  ? moment(message.timestamp).fromNow()
                                  : moment(message.timestamp).format("lll")}
                              </span>
                            </span>
                          </div>
                        ))}
                      </div>
                      <div ref={messagesEndRef}></div>
                      <form
                        className="conversation-compose"
                        onSubmit={sendMessage}
                      >
                        <div className="emoji">
                          <label
                            htmlFor="file-input"
                            style={{ cursor: "pointer" }}
                          >
                            <svg
                              width="24"
                              height="24"
                              viewBox="0 0 24 24"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                fillRule="evenodd"
                                clipRule="evenodd"
                                d="M9 7C9 4.23858 11.2386 2 14 2C16.7614 2 19 4.23858 19 7V15C19 18.866 15.866 22 12 22C8.13401 22 5 18.866 5 15V9C5 8.44772 5.44772 8 6 8C6.55228 8 7 8.44772 7 9V15C7 17.7614 9.23858 20 12 20C14.7614 20 17 17.7614 17 15V7C17 5.34315 15.6569 4 14 4C12.3431 4 11 5.34315 11 7V15C11 15.5523 11.4477 16 12 16C12.5523 16 13 15.5523 13 15V9C13 8.44772 13.4477 8 14 8C14.5523 8 15 8.44772 15 9V15C15 16.6569 13.6569 18 12 18C10.3431 18 9 16.6569 9 15V7Z"
                                fill="currentColor"
                              />
                            </svg>
                          </label>
                        </div>

                        <input
                          type="text"
                          placeholder="Type your message ..."
                          value={message}
                          onChange={(e) => setMessage(e.target.value)}
                          className="input-msg"
                          autoComplete="off"
                          autoFocus
                        />

                        <div className="photo">
                          <input
                            type="file"
                            id="file-input"
                            accept="image/*"
                            style={{ display: "none" }}
                            onChange={handleFileChange}
                          />
                        </div>

                        <button className="send">
                          <div className="circle">
                            <i className="mdi mdi-send"></i>
                          </div>
                        </button>
                      </form>
                      {filePreview && (
                        <div className="preview-card float-end">
                          <sup
                            className="float-end"
                            title="Remove"
                            onClick={removeFilePreview}
                          >
                            <i className="fa fa-trash"></i>
                          </sup>

                          {/* Show loader while compressing, otherwise show image preview */}
                          {isCompressing ? (
                            <div className="compression-loader">
                              <p>Compressing...</p>
                            </div>
                          ) : (
                            <img alt="Preview" src={filePreview} />
                          )}
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
}
